import React, { Fragment, useState } from "react";
import dayjs from "dayjs";
import { NavLink } from "../../lib/Navigation";
import general from "../../general";
import { useThrottleEffect } from "ahooks";
import { CSSTransition } from "react-transition-group";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import Dialog from "../../lib/Dialog";

export default () => {
  const game = general.game;
  const gifts = game.gift_bag_list || [];
  const [groups, setGroups] = useState([]);
  useThrottleEffect(() => {
    let groups = {};
    for (const gift of gifts) {
      let id = "default";
      let name = "免费礼包";
      if (gift.is_vip == 2 || gift.member_level_limit > 0) {
        id = "special";
        name = "特权礼包";
      } else if (gift.recharge_amount > 0) {
        id = "recharge";
        name = "充值礼包";
      }
      if (!groups[id]) {
        groups[id] = {
          id,
          name,
          gifts: [],
        };
      }
      groups[id].gifts.push(gift);
    }
    setGroups(Object.entries(groups).map(([_, group]) => group));
  });

  const [gift, setGift] = useState({});
  const [giftShow, setGiftShow] = useState();
  const [giftCode, setGiftCode] = useState();
  const giftReceive = (gift) => {
    if (gift.unicode != 1 && gift.surplus_num < 1) {
      return;
    }
    Dialog.loading();
    general.axios
      .post("/base/game/getReceiveGift", { gift_id: gift.packid })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setGiftShow(false);
          setGiftCode(data);
        }
      })
      .catch((err) => {
        Dialog.error("getReceiveGift " + err.message);
      });
  };

  return (
    <>
      {groups.length > 0 ? (
        <div className="game-detail">
          <div className="game-gift">
            <div className="groups">
              {groups.map((group, index) => (
                <Fragment key={index}>
                  <div className="group">
                    <div className="name">{group.name}</div>
                    <div className="items">
                      {group.gifts?.map((gift, index) => (
                        <Fragment key={index}>
                          <div
                            className="item"
                            onClick={() => {
                              setGift(gift);
                              setGiftShow(true);
                            }}
                          >
                            <div className="info">
                              <div className="name">
                                <div className="named">{gift.packname}</div>
                                {gift.is_vip == 2 ||
                                gift.member_level_limit > 0 ? (
                                  <>
                                    <div className="special">
                                      <div className="label">
                                        {gift.member_level_limit > 0
                                          ? `Lv${gift.member_level_limit}`
                                          : "VIP"}
                                      </div>
                                      <div className="value">专享</div>
                                    </div>
                                  </>
                                ) : null}
                              </div>
                              <div className="desc">
                                {gift.packcontent}
                                <br />
                                有效期：
                                {dayjs
                                  .unix(gift.starttime)
                                  .format("YYYY-MM-DD")}{" "}
                                至{" "}
                                {dayjs.unix(gift.endtime).format("YYYY-MM-DD")}
                              </div>
                            </div>
                            <NavLink
                              className={`operate ${
                                gift.unicode != 1 && gift.surplus_num < 1
                                  ? "nothing"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                giftReceive(gift);
                              }}
                            />
                          </div>
                        </Fragment>
                      ))}
                    </div>
                  </div>
                </Fragment>
              ))}
            </div>
          </div>

          <CSSTransition in={giftShow} timeout={250} unmountOnExit={true}>
            <div className="gift-detail">
              <div className="gift-mask" onClick={() => setGiftShow(false)} />
              <div className="gift-container">
                <div className="gift-top">
                  <div className="text">
                    <div className="name">
                      <div className="named">{gift.packname}</div>
                      {gift.is_vip == 2 || gift.member_level_limit > 0 ? (
                        <>
                          <div className="special">
                            <div className="label">
                              {gift.member_level_limit > 0
                                ? `Lv${gift.member_level_limit}`
                                : "VIP"}
                            </div>
                            <div className="value">专享</div>
                          </div>
                        </>
                      ) : null}
                    </div>
                    <div className="time">
                      有效期：
                      {dayjs.unix(gift.endtime).format("YYYY-MM-DD HH:mm:ss")}
                    </div>
                  </div>
                </div>
                <div className="gift-main">
                  <div className="gift-desc">
                    <div className="title">礼包说明</div>
                    <div className="main">{gift.packcontent}</div>
                  </div>
                </div>
                <NavLink
                  className="gift-bottom"
                  onClick={() => giftReceive(gift)}
                >
                  领取
                </NavLink>
              </div>
            </div>
          </CSSTransition>
          {giftCode ? (
            <div className="dialog active">
              <div className="dialog-mask" />
              <div className="dialog-content">
                <div className="dialog-modal">
                  <div className="modal-body">
                    <div className="modal-title">领取成功</div>
                    <div className="modal-content">{giftCode}</div>
                  </div>
                  <div className="modal-btns">
                    <div className="modal-btn">
                      <CopyToClipboard
                        text={giftCode}
                        onCopy={() => Dialog.info("已复制")}
                      >
                        <div onClick={() => setGiftCode(null)}>复制</div>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <div
          style={{
            backgroundColor: "#fff",
            textAlign: "center",
            paddingTop: "150px",
          }}
        >
          <img style={{ width: "70%" }} src="/resources/empty.png" alt="" />
          <p>暂无礼包可领取~</p>
        </div>
      )}
    </>
  );
};
